import Api from '@/common/js/api';
import ThirdApiConfig from '@/common/js/thirdApiConfig';
import ajax from '@/common/js/utils/ajax';
import Storage from '@/common/js/utils/storage';
import Cookie from '@/common/js/utils/cookie';
import {Toast} from "vant"

let actions = {

    // 设置本地存储
    __setStorage(store, params = {}) {
        if (params === 'remove') {
            Storage.remove('hxb-isLogin');
        } else {
            Storage.add('hxb-isLogin', params);
        }
    },

    // 清除用户信息, 重置
    __clearUser(store, oValue) {
        let {dispatch} = store;
        dispatch('__setStorage', 'remove');
    },

    // 白名单以外的用户
    __toWhilePage() {
        window.location.hash = '/notWhitePage';
    },

    // 联合登录, 去星团的路由地址
    __reloadUnionLogin(store) {
        let {state, dispatch, commit} = store;
        let params = '';
        let {url, flowRouter} = ThirdApiConfig.stardust;
        let flowCode = Cookie.getCookie('flow_owner_code') || '';
        let subChannel = Cookie.getCookie('sub_channel') || '';

        if (!url) return console.error('ThirdApiConfig.stardust {url} undefined');
        if (!flowCode) {
            return commit('Alert/show', {
                text: '跳转登录异常, 请退出重试',
                callback: () => {}
            });
        }

        if (subChannel) {
            subChannel = `&sub_channel=${subChannel}`;
        }

        if (flowCode) {
            flowCode = `?flow_owner_code=${flowCode}`;
        }

        window.location.href = url + flowRouter + `${flowCode}${subChannel}`;
    },

    // 未登录, 登录超时, 无权限
    __reloadLogin(store, oValue) {
        if (Number(oValue.code) == 101027) {
            let {origin, pathname, hash, search} = window.location;
            let random = '_random=' + Date.now();

            // 302重定向手机端安卓浏览器不会发起请求, 导致页面无法加载和初始化
            // 所以加一个动态参数区分
            if (search.indexOf('?') > -1) {
                search += '&' + random;
            } else {
                search += '?' + random;
            }
            window.location.href = Api.wechatAuth + '?ref=' + encodeURIComponent(origin + pathname + search + hash);
            return false;
        }
        store.commit('Alert/show', {
            text: oValue.msg,
            closeBtn: false,
            callback: () => {
                store.dispatch('__clearUser');
                //window.location.hash = '/login?currType=login';
            }
        });
    },

    // 系统维护升级
    // __updating(store, oValue) {
    //     window.location.hash = '/updating';
    // },

    // 公用处理回调
    publicCallback(store, param) {
        let {state, dispatch, commit} = store;
        let res = param.res;
        let callback = param.callback;
        let apiKey = state.apiStateKey;
        commit('Loading/close', {}, {root: true});

        if (callback && typeof callback !== 'function') return;
        try {
            res = (typeof res === 'object') ? res : JSON.parse(res);
        } catch (err) {
            return commit('Alert/show', {
                text: '解析错误parsererror!'
            });
        }

        // 根據code碼判斷
        let code = res.code;
        if (code in apiKey) {
            return dispatch(apiKey[code][0], {
                msg: apiKey[code][1],
                type: apiKey[code][0],
                code: code
            });
        }

        res.msg = res.message;
        callback(res.data || {}, code, res);
    },

    // 公用错误处理回调
    publicErrorCallback(store, param) {
        let {state, dispatch, commit} = store;
        let callback = param.callback;
        let xhr = param.xhr;
        let tipText = "操作异常";
        let oError = {
            "timeout": "请求超时",
            "error": "网络连接错误",
            "parsererror": "解析错误parsererror",
            "500": "服务器内部错误"
        };

        if (xhr.statusText) tipText = xhr.statusText;
        if (oError[xhr.type]) tipText = oError[xhr.type];
        if (oError[xhr.status]) tipText = oError[xhr.status];

        commit('Loading/close', {}, {root: true});
        (typeof callback === 'function') && callback(tipText);
    },

    // 获取用户基本资料{/quotaQuery}
    getUserInfo(store, param = {}) {
        const {state, commit, dispatch} = store;
        const handleBack = param.handleBack || function() {};
        delete param.handleBack;

        let type = param.type || 'qnUserInfo';
        const params = {
            url: Api[type],
            data: param
        };

        delete param.type;

        commit('Loading/show', {}, {root: true});
        let xmlHttp = ajax.get(params);
        xmlHttp.promise.then((res) => {
            store.dispatch('publicCallback', {
                res: res,
                callback: (data, code, res) => {
                    if (~~code !== 0) {
                        return commit('Toast/show', {text: res.msg || '操作异常'}, {root: true});
                    }
                    if (param.channel_code && param.channel_code === 'app_jn_huiji_life') {
                        data.identity_ocr_status = 'noNeed' //存在渠道号时，禁止修改身份证
                    }
                    // 获取用户信息和企业类型和银行卡信息
                    Object.assign(state.userInfo, {
                        individual: data.individual || {},
                        bank_info: data.bank_info || {},
                        identity_ocr_status: data.identity_ocr_status || null,
                        first_register: data.first_register || {}
                    });
                    state.companyTypeSelect = data.company_type || [];
                    handleBack();
                }
            }, {root: true});
        }, (error) => {
            store.dispatch('publicErrorCallback', {
                xhr: error.xhr,
                callback: (tipText) => {
                    commit('Toast/show', {text: tipText}, {root: true});
                }
            }, {root: true});
        });
    },

    // 获取验证码
    sendVerifyCode(store, param) {
        const {state, commit, dispatch} = store;
        const handleBack = param.handleBack || function() {};
        delete param.handleBack;
        let url;
        // let sendVerifyCode = ['change_phone', 'bind_card'];
        let sendVerifyCode = ['change_phone'];

        if (sendVerifyCode.includes(param.scene)) {
            url = Api.qnUserBindMsg;  // 共用发送
            delete param['scene'];
        } else if (param.scene === 'promotion' || param.scene === 'lpr') {
            url = Api.checkVerify;  // 发验证码接口{线下推广 || lpr网贷签约}
        } else {
            url = Api.phoneVerify;  // 总行发验证码接口{注册}
        }

        const params = {
            url: url,
            data: param
        };

        commit('Loading/show', {}, {root: true});
        let xmlHttp = ajax.post(params);
        xmlHttp.promise.then((res) => {
            store.dispatch('publicCallback', {
                res: res,
                callback: (data, code, res) => {
                    if (~~code !== 0) {
                        return commit('Toast/show', {text: res.msg || '操作异常'}, {root: true});
                    }
                    handleBack();
                }
            }, {root: true});
        }, (error) => {
            store.dispatch('publicErrorCallback', {
                xhr: error.xhr,
                callback: (tipText) => {
                    commit('Toast/show', {text: tipText}, {root: true});
                }
            }, {root: true});
        });
    },

    // 银行卡ocr识别
    // upload(store, param) {
    //     param.url = Api.upload;
    //     ajax.upload(param);
    // },

    // 首页
    siteIndex(store, param = {}) {
        const {state, commit, dispatch} = store;
        const handleBack = param.handleBack || function() {};
        const hideLoading = param.hideLoading;
        delete param.handleBack;
        delete param.hideLoading;
        const params = {
            url: Api.qnSiteIndex,
            data: param
        };

        // 初次隐藏loading {f5,强刷新时} Loading store未注册
        !hideLoading && commit('Loading/show', {}, {root: true});
        let xmlHttp = ajax.post(params);
        xmlHttp.promise.then((res) => {
            store.dispatch('publicCallback', {
                res: res,
                callback: (data, code, res) => {
                    if (~~code !== 0) {
                        if(code == 101027) { // 微信没有登录
                            this.$store.dispatch('__reloadLogin', res)
                            return
                        }
                        return commit('Toast/show', {text: res.msg || '操作异常'}, {root: true});
                    }

                    let homeRelation = state.homeRelation;
                    let homeState = '';
                    state.hideLoading = false;

                    // 未注册
                    if (data.user_status === 'not_register') {
                        dispatch('__setStorage', 'remove');
                    } else {
                        dispatch('__setStorage', 1);
                    }

                    // 用户状态
                    if (data.user_status in homeRelation) {
                        homeState = homeRelation[data.user_status];
                    } else {

                        // 借款状态
                        if (data.loan_status in homeRelation) {
                            homeState = homeRelation[data.loan_status];
                        }

                        // 额度状态
                        if (data.quota.status in homeRelation) {
                            homeState = homeRelation[data.quota.status];
                        }
                    }

                    // 设置中断状态
                    Object.assign(state.userInfo, {
                        step: {
                            quotaStatus: data.quota.status,
                            loanStatus: data.loan_status
                        },
                        userStatus: data.user_status,
                        user_bind_card2: data.user_bind_card2 || null,
                        homeState: homeState,
                        repay_status: data.repay_status,
                        user_info_status: data.user_info_status || null,
                        error_toast: data.error_toast || '',
                        canLoanAmount: data.quota.can_loan_amount,
                        totalLoanAmount: data.quota.total_loan_amount,
                        apply_allow: data.quota.apply_allow,
                        biz_stop_open_card2: data.biz_stop_open_card2,
                        loan_rate: data.loan_rate,
                        service_stop_tips: data.service_stop_tips
                    });

                    console.log(state);
                    handleBack(res);
                }
            }, {root: true});
        }, (error) => {
            store.dispatch('publicErrorCallback', {
                xhr: error.xhr,
                callback: (tipText) => {
                    commit('Toast/show', {text: tipText}, {root: true});
                }
            }, {root: true});
        });
    },

    // lpr首页
    lprSiteIndex(store, param = {}) {
        const {state, commit, dispatch} = store;
        const handleBack = param.handleBack || function() {};
        const hideLoading = param.hideLoading;
        delete param.handleBack;
        delete param.hideLoading;
        const params = {
            url: Api.lprSiteIndex,
            data: param
        };

        // 初次隐藏loading {f5,强刷新时} Loading store未注册
        !hideLoading && commit('Loading/show', {}, {root: true});
        let xmlHttp = ajax.post(params);
        xmlHttp.promise.then((res) => {
            store.dispatch('publicCallback', {
                res: res,
                callback: (data, code, res) => {
                    if (~~code !== 0) {
                        return commit('Toast/show', {text: res.msg || '操作异常'}, {root: true});
                    }

                    state.hideLoading = false;

                    // 设置中断状态
                    Object.assign(state.lprUserInfo, {
                        userStatus: data.user_status,
                        face_status: data.face_status,
                        first_register_toast: data.first_register_toast,
                        check_individual_validity: data.check_individual_validity,
                        error_toast: data.error_toast || '',
                        service_stop_tips: data.service_stop_tips
                    });

                    console.log(state);
                    handleBack();
                }
            }, {root: true});
        }, (error) => {
            store.dispatch('publicErrorCallback', {
                xhr: error.xhr,
                callback: (tipText) => {
                    commit('Toast/show', {text: tipText}, {root: true});
                }
            }, {root: true});
        });
    },
    // 是否展示免息劵
    showInterestFreeCoupon({state, commit, dispatch}) {
        return new Promise((resolve, reject) => {
            ajax.post({
                url: Api.showInterestFreeCoupon
            }).promise.then(resolve, reject)
        })
    },
    // 是否展示免息劵
    reportInterestFreeCoupon({state, commit, dispatch}) {
        ajax.post({
            url: Api.reportInterestFreeCoupon
        })
    },
    // 获取免息劵列表
    getInterestFreeList(store) {
        return new Promise((resolve, reject) => {
            ajax.post({
                url: Api.userAvailableInterestFreeCoupon
            }).promise.then(resolve, reject)
        })
    },
    // 获取人脸认证URL
    webankFaceid(store, param = {}) {
        const {state, commit, dispatch} = store;
        const handleBack = param.handleBack;
        delete param.handleBack;

        let type = param.type || 'v2ValidationFaceid';
        const params = {
            url: Api[type],
            data: param
        };
        delete param.type;

        commit('Loading/show', {}, {root: true});
        let xmlHttp = ajax.post(params);
        xmlHttp.promise.then((res) => {
            store.dispatch('publicCallback', {
                res: res,
                callback: (data, code, res) => {
                    if (~~code !== 0) {
                        return commit('Toast/show', {text: res.msg || '操作异常'}, {root: true});
                    }
                    data.url && handleBack(data.url);
                }
            }, {root: true});
        }, (error) => {
            store.dispatch('publicErrorCallback', {
                xhr: error.xhr,
                callback: (tipText) => {
                    commit('Toast/show', {text: tipText}, {root: true});
                }
            }, {root: true});
        });
    },

    // 获取ocr url
    ocr(store, param = {}) {
        const {state, commit, dispatch} = store;
        const handleBack = param.handleBack;
        delete param.handleBack;
        const params = {
            url: Api[param.type],
            data: param
        };
        delete param.type;

        commit('Loading/show', {}, {root: true});
        let xmlHttp = ajax.post(params);
        xmlHttp.promise.then((res) => {
            store.dispatch('publicCallback', {
                res: res,
                callback: (data, code, res) => {
                    if (~~code !== 0) {
                        return commit('Toast/show', {text: res.msg || '操作异常'}, {root: true});
                    }
                    data.url && handleBack(data.url);
                }
            }, {root: true});
        }, (error) => {
            store.dispatch('publicErrorCallback', {
                xhr: error.xhr,
                callback: (tipText) => {
                    commit('Toast/show', {text: tipText}, {root: true});
                }
            }, {root: true});
        });
    },

    // 微信人脸-提交人脸结果
    submitFaceid(store, param = {}) {
        const {state, commit, dispatch} = store;
        const handleBack = param.handleBack || function() {};
        delete param.handleBack;
        const params = {
            url: Api.identityGetinfo,
            data: param
        };

        commit('Loading/show', {}, {root: true});
        let xmlHttp = ajax.post(params);
        xmlHttp.promise.then((res) => {
            store.dispatch('publicCallback', {
                res: res,
                callback: (data, code, res) => {
                    if (~~code !== 0) {
                        return commit('Toast/show', {
                            text: res.msg || '操作异常',
                            callback: (type) => {
                                if (type !== 'auto') return;
                                window.location.reload();
                            }
                        }, {root: true});
                    }

                    handleBack(~~data.status);
                }
            }, {root: true});
        }, (error) => {
            store.dispatch('publicErrorCallback', {
                xhr: error.xhr,
                callback: (tipText) => {
                    commit('Toast/show', {text: tipText}, {root: true});
                }
            }, {root: true});
        });
    },

    // 小程序人脸识别结果跳转
    v1WebankCallbackFaceid(store, param = {}) {
        const {state, commit, dispatch} = store;
        const handleBack = param.handleBack || function() {};
        delete param.handleBack;
        const params = {
            url: Api.v1WebankCallbackFaceid,
            data: param
        };

        commit('Loading/show', {}, {root: true});
        let xmlHttp = ajax.post(params);
        xmlHttp.promise.then((res) => {
            store.dispatch('publicCallback', {
                res: res,
                callback: (data, code, res) => {
                    if (~~code !== 0) {
                        return commit('Alert/show', {
                            text: res.msg || '操作异常',
                            callback: () => {
                                window.location.reload();
                            }
                        });
                    }

                    handleBack();
                }
            }, {root: true});
        }, (error) => {
            store.dispatch('publicErrorCallback', {
                xhr: error.xhr,
                callback: (tipText) => {
                    commit('Toast/show', {text: tipText}, {root: true});
                }
            }, {root: true});
        });
    },

    // lpr路由中断状态计算
    lprProcessComputed(store, param = {}) {
        let handleBack = param.handleBack || function() {};
        let {register} = param;
        let {state, commit} = store;
        let {userStatus, face_status} = state.lprUserInfo;

        // 没有注册
        if (userStatus === 'not_register') {
            return handleBack('lprReg');
        }

        // 人脸认证
        if (face_status === 'faceid_verify') {
            return handleBack('lprFaceidVerify');
        }

        handleBack(param.toName);
    },

    // 路由中断状态计算
    processComputed(store, param = {}) {
        let handleBack = param.handleBack || function() {};
        let {register} = param;
        let {state, commit} = store;
        let {userStatus, user_bind_card2} = state.userInfo;
        let {quotaStatus, loanStatus} = state.userInfo.step;
        let repayNames = ['repaymentList', 'planList'];

        // 没有注册
        if (userStatus === 'not_register') {
            return handleBack('quotaQuery');
        }

        // 已注册，但是他行卡二类户
        // 且访问的不是{还款}一系列的url
        if (userStatus === 'active' && user_bind_card2 === 'none_outer' && !repayNames.includes(param.toName)) {
            // return commit('Alert/show', {
            //     text: '请开通他行卡二类户',
            //     closeBtn: false,
            //     callback: () => {
            //         handleBack('bindOuterCardII');
            //     }
            // });
            return handleBack('bindOuterCardII');
        }

        // 已注册，但未补充企业信息
        // 且访问的不是{还款}一系列的url
        if (userStatus === 'no_company' && !repayNames.includes(param.toName)) {
            return handleBack('formAdditional');
        }

        // 已注册，但未填写职业信息
        // 且访问的不是{还款}一系列的url
        if (userStatus === 'no_work_info' && !repayNames.includes(param.toName)) {
            return handleBack('addWorkInfo');
        }

        // 已注册，但未填写紧急联系人
        // 且访问的不是{还款}一系列的url
        if (userStatus === 'no_contact' && !repayNames.includes(param.toName)) {
            return handleBack('addContact');
        }

        // 已注册, 但不在白名单内
        if (userStatus === 'no_quali') {
            return handleBack('notWhitePage');
        }

        // 如果没有生成流程状态
        // 两条流程以外的界面, 只判断: 否注册和是否在白名单, 比如[/user, /repayment]
        if (!quotaStatus || !loanStatus || register) {
            return handleBack(param.toName);
        }

        // 授信需要人脸认证
        if (quotaStatus === 'faceid_verify') {
            return handleBack('quotaQueryFaceidVerify');
        }

        // 授信状态计算中
        if (quotaStatus === 'result_waiting') {
            return handleBack('polling');
        }

        // 授信 [暂无资质、已过期]
        if (['no_quali', 're_verify'].includes(quotaStatus)) {
            return handleBack('quotaQueryResult');
        }

        // 1、授信有资质
        // 2、无贷款记录
        // 3、有贷款记录且处于还款状态
        if (quotaStatus === 'normal' || ['none', 'repaying'].includes(loanStatus)) {

            // 访问授信结果页面
            if (param.toName === 'quotaQueryResult') {
                return handleBack('home');
            }

            // 访问授信人脸页面
            if (param.toName === 'quotaQueryFaceidVerify') {
                return handleBack('home');
            }

            // 访问紧急联系人页面
            if (param.toName === 'addContact') {
                return handleBack('home');
            }

            // 访问职业信息页面
            if (param.toName === 'addWorkInfo') {
                return handleBack('home');
            }

            // 访问企业信息页面
            if (param.toName === 'formAdditional') {
                return handleBack('home');
            }
        }

        // 借款中
        if (loanStatus === 'grant_waiting') {
            return handleBack('loanPolling');
        }

        handleBack(param.toName);
    },

    // 失去焦点
    blur(store) {
        try {
            let {state} = store;
            let activeEl = document.activeElement;
            if (!state) return;
            if (!state.blurType.includes(activeEl.tagName)) return;
            activeEl.blur();
        } catch(err) {}
    },

    // 获取焦点
    focus(store, elName) {
        let dom = document.getElementById(elName);
        if (!dom) return;
        dom.focus();
    },

    // 加入http取消队列的api
    // dispatch('addHttpCancelQueue', {api: 'ocrBankcard', abort: xmlHttp.abort}, {root: true});
    addHttpCancelQueue(store, param) {
        let {state} = store;
        let api = param.api;
        let abort = param.abort;
        if (!api || typeof abort !== 'function') return;
        state.xmlHttpCancelQueue[api] = param.abort;
    },

    // 取消http请求 全部取消 或 指定的api
    // dispatch('cancelAjax', {api: 'ocrBankcard', handle: () => {}});
    cancelAjax(store, param = {}) {
        let {state} = store;
        let queue = state.xmlHttpCancelQueue;
        let handle = param.handle;
        let api = param.api;

        if (handle && typeof handle !== 'function') return;
        if (!Object.keys(queue).length) return;

        if (api) return queue[api](handle);
        for (let i in queue) queue[i](handle);
        state.xmlHttpCancelQueue = {};
    },

    // pvUv统计
    reportBlPvUv(store, param = {}) {
        let {dispatch} = store;
        dispatch('reportBl', {evtName: 'pvUv', opt: param});
    },

    // 按钮统计
    reportBlOnBtn(store, param = {}) {
        let {dispatch} = store;
        let opt = {};

        if (typeof param === 'object') {
            Object.assign(opt, param);
        } else {
            opt.behaviour_event = param;
        }

        dispatch('reportBl', {evtName: 'onBtn', opt});
    },

    // 统计埋点动作
    // evtName [onBtn, pvUv]
    reportBl(store, param = {}) {
        let {evtName, opt} = param;
        if (typeof KnTJ === 'undefined') {
            return console.error('reportBl action KnTJ is undefined');
        }

        if (typeof KnTJ[evtName] === 'undefined') {
            return console.error(`KnTJ.${evtName} is undefined`);
        }

        KnTJ[evtName](opt);
    },

    // 判断服务时间, 比如：是否能注册，是否能借款，或者其他
    serviceStopTips(store, param = {}) {
        let handleBack = param.handleBack || function() {};
        let {state, commit} = store;
        let {userStatus, service_stop_tips, step} = state.userInfo;
        let {quotaStatus, loanStatus} = step;
        let openTip = false;

        // 判断是否在时间内（20200702注释不分注册和进件）
        // let notServiceTime = (o = {}) => {
        //     let cTime = new Date();

        //     if (!o.start || !o.end) {
        //         console.error('notServiceTime function param start or end time field require');
        //         return false;
        //     }

        //     let start = new Date(o.start).getTime();
        //     let end = new Date(o.end).getTime();

        //     // 如果当前时间大于开始 且 小于结束时间
        //     // return true表示在此时间范围内
        //     return cTime > start && cTime < end;
        // };

        // 不需要判断是否在系统维护或者其他原因的时间内, 此时字段为0
        if (!service_stop_tips) return handleBack(false);

        // let {can_register, can_apply, tips, register, apply} = service_stop_tips;

        // 提示用户当前时间不可注册
        // 用户未注册
        if (userStatus === 'not_register' && service_stop_tips) {
            // openTip = true;
            return handleBack(true);
        }

        // 提示用户当前时间不可借款
        // 用户已注册active, 已出额normal, 需要人脸认证faceid_verify, 已过期re_verify, 无贷款中none
        if (userStatus === 'active' && ['normal', 're_verify', 'faceid_verify'].includes(quotaStatus) && loanStatus === 'none' && service_stop_tips) {
            // openTip = true;
            return handleBack(true);
        }

        // 开启提示, 阻塞后面的执行返回true
        // if (openTip) {
        //     commit('Alert/show', {
        //         text: tips,
        //         align: 'left',
        //         closeBtn: false,
        //         callback: () => {}
        //     });
        //     return true;
        // }
        return handleBack(false);
    },
    // 获取用户基本资料{/lpr}
    lprGetUserInfo(store, param = {}) {
        const {state, commit, dispatch} = store;
        const handleBack = param.handleBack || function() {};
        delete param.handleBack;

        const params = {
            url: Api.lprUserInfo,
            data: param
        };

        commit('Loading/show', {}, {root: true});
        let xmlHttp = ajax.get(params);
        xmlHttp.promise.then((res) => {
            store.dispatch('publicCallback', {
                res: res,
                callback: (data, code, res) => {
                    if (~~code !== 0) {
                        return commit('Toast/show', {text: res.msg || '操作异常'}, {root: true});
                    }
                    // 获取用户信息
                    Object.assign(state.lprUserInfo, {
                        individual: data.individual || {},
                        identity_ocr_status: data.identity_ocr_status || null,
                        first_register: data.first_register || {}
                    });
                    handleBack();
                }
            }, {root: true});
        }, (error) => {
            store.dispatch('publicErrorCallback', {
                xhr: error.xhr,
                callback: (tipText) => {
                    commit('Toast/show', {text: tipText}, {root: true});
                }
            }, {root: true});
        });
    },
    commonRequest(store, param = {}) {
        const { commit, dispatch } = store;
        const handleBack = param.handleBack || function() {};
        const errorBack = param.errorBack || function() {};
        const method = param.type || 'post'
        delete param.handleBack;
        delete param.errorBack;

        const params = {
            url: param.api,
            data: param.data || {}
        };

        commit('Loading/show', {}, {root: true});
        let xmlHttp = ajax[method](params);
        xmlHttp.promise.then((res) => {
            store.dispatch('publicCallback', {
                res: res,
                callback: (data, code, res) => {
                    if (code !== 0) {
                        return Toast(res.message || res.msg || '操作异常')
                    }

                    handleBack(data, res);
                }
            }, {root: true});
        }, (error) => {
            store.dispatch('publicErrorCallback', {
                xhr: error.xhr,
                callback: (tipText) => {
                    Toast(tipText)
                    errorBack && errorBack(tipText)
                }
            }, {root: true});
        });
    },
    // 获取人脸认证结果
    getFaceidResult(store, param = {}) {
        const {state, commit, dispatch} = store;
        const handleBack = param.handleBack;
        delete param.handleBack;
        const params = {
            url: Api.qnFaceidWebankResult,
            data: param
        };

        commit('Loading/show', {}, {root: true});
        return new Promise((resolve, reject) => {
            let xmlHttp = ajax.post(params);
            xmlHttp.promise.then((res) => {
                store.dispatch('publicCallback', {
                    res: res,
                    callback: (data, code, res) => {
                        if (~~code !== 0) {
                            reject()
                            return commit('Toast/show', {text: res.msg || '操作异常'}, {root: true});
                        }
                        resolve(data);
                    }
                }, {root: true});
            }, (error) => {
                reject()
                store.dispatch('publicErrorCallback', {
                    xhr: error.xhr,
                    callback: (tipText) => {
                        commit('Toast/show', {text: tipText}, {root: true});
                    }
                }, {root: true});
            });
        })
    },
    // 获取ocr地址
    getOcrUrl(store, param = {}) {
        const {state, commit, dispatch} = store;
        const params = {
            url: Api.qnWebankUrl,
            data: param
        };
        commit('Loading/show', {}, {root: true});

        return new Promise((resolve, reject) => {
            let xmlHttp = ajax.post(params);
            xmlHttp.promise.then((res) => {
                store.dispatch('publicCallback', {
                    res: res,
                    callback: (data, code, res) => {
                        if (~~code !== 0) {
                            reject()
                            return commit('Toast/show', {text: res.msg || '操作异常'}, {root: true});
                        }
                        data.url && resolve(data.url);
                    }
                }, {root: true});
            }, (error) => {
                reject()
                store.dispatch('publicErrorCallback', {
                    xhr: error.xhr,
                    callback: (tipText) => {
                        commit('Toast/show', {text: tipText}, {root: true});
                    }
                }, {root: true});
            });
        })
    },
    // 获取人脸认证URL
    getFaceidUrl(store, param = {}) {
        const {state, commit, dispatch} = store;

        const params = {
            url: Api.qnFaceidWebankUrl,
            data: param
        };

        commit('Loading/show', {}, {root: true});
        return new Promise((resolve, reject) => {
            let xmlHttp = ajax.post(params);
            xmlHttp.promise.then((res) => {
                store.dispatch('publicCallback', {
                    res: res,
                    callback: (data, code, res) => {
                        if (~~code !== 0) {
                            reject()
                            return commit('Toast/show', {text: res.msg || '操作异常'}, {root: true});
                        }
                        data.url && resolve(data.url);
                    }
                }, {root: true});
            }, (error) => {
                reject()
                store.dispatch('publicErrorCallback', {
                    xhr: error.xhr,
                    callback: (tipText) => {
                        commit('Toast/show', {text: tipText}, {root: true});
                    }
                }, {root: true});
            });
        })
    },
    // 产品列表
    getProductList(store, param = {}) {
        const {state, commit, dispatch} = store;
        commit('Loading/show', {}, {root: true});

        return new Promise((resolve, reject) => {
            ajax.post({
                url: Api.qnProductList,
                data: param
            }).promise.then(res => {
                store.dispatch('publicCallback', {
                    res: res,
                    callback: (data, code, res) => {
                        if (~~code !== 0) {
                            if(~~code === 101027) { // 微信没有登录
                                this.$store.dispatch('__reloadLogin', res)
                                return reject()
                            }
                            commit('Toast/show', {text: res.msg || '操作异常'}, {root: true});
                            return reject()
                        }
                        commit('setValue', {
                            key: 'productList',
                            value: data.product_list || []
                        });
                        return resolve(data)
                    }
                }, {root: true});
            }).catch(error => {
                dispatch('publicErrorCallback', {
                    xhr: error.xhr,
                    callback: (tipText) => {
                        commit('Toast/show', {text: tipText}, {root: true});
                    }
                }, {root: true});
                return reject()
            })
        })
    },
    // 产品详情
    qnSiteIndex(store, param = {}) {
        const {state, commit, dispatch} = store;
        const params = {
            url: Api.qnSiteIndex,
            data: param
        };

        commit('Loading/show', {}, {root: true});
        let xmlHttp = ajax.post(params);
        return new Promise((resolve, reject) => {
            xmlHttp.promise.then((res) => {
                store.dispatch('publicCallback', {
                    res: res,
                    callback: (data, code, res) => {
                        if (~~code !== 0) {
                            if(code == 101027) { // 微信没有登录
                                this.$store.dispatch('__reloadLogin', res)
                                return reject()
                            }
                            commit('Toast/show', {text: res.msg || '操作异常'}, {root: true});
                            return reject()
                        }
                        return resolve(data)
                    }
                }, {root: true});
            }).catch((error) => {
                store.dispatch('publicErrorCallback', {
                    xhr: error.xhr,
                    callback: (tipText) => {
                        commit('Toast/show', {text: tipText}, {root: true});
                    }
                }, {root: true});
                return reject()
            })
        })
    },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/actions.js